import { useCallback } from "react";
import { OutlookDeepLinkParam } from "../../system/types/meetingRoom/MeetingRoom";

export const useOutlookDeeplink = () => {
  const openOutlookPopup = useCallback(
    (params: OutlookDeepLinkParam[] = [], refetchFunc) => {
      const outlookUrl = new URL(
        "https://outlook.office.com/calendar/deeplink/compose"
      );

      params.forEach(({ key, value }) => {
        outlookUrl.searchParams.set(key, value);
      });

      const popup = window.open(
        outlookUrl.toString(),
        "OutlookPopup",
        "width=1200,height=900,menubar=no,toolbar=no,location=no,status=no"
      );

      if (popup) {
        const checkPopupClosed = setInterval(() => {
          if (popup.closed) {
            clearInterval(checkPopupClosed);
            refetchFunc(); // 팝업 닫힐 때 재조회 함수 호출
          }
        }, 500);
      }
    },
    []
  );

  const openOutlookUpdateDeepLink = useCallback((webLink, refetchFunc) => {
    const popup = window.open(
      webLink,
      "OutlookPopup",
      "width=1400,height=900,menubar=no,toolbar=no,location=no,status=no"
    );

    if (popup) {
      const checkPopupClosed = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkPopupClosed);
          refetchFunc(); // 팝업 닫힐 때 재조회 함수 호출
        }
      }, 500);
    }
  }, []);

  return { openOutlookPopup, openOutlookUpdateDeepLink };
};
